<template>
  <transition name="modal-fade">
    <div v-if="show" class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div class="relative w-full max-w-md bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
        <!-- Header -->
        <div class="bg-gradient-to-r from-blue-600 to-indigo-700 px-4 py-4">
          <div class="flex items-center justify-center gap-3">
            <div class="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h3 class="text-lg font-bold text-white">{{ $t('privacyBanner.title') }}</h3>
          </div>
        </div>

        <!-- Content -->
        <div class="p-6">
          <div class="space-y-4">
            <div class="text-gray-700 text-sm leading-relaxed">
              <p class="mb-3">
                {{ $t('privacyBanner.intro') }} <strong class="text-blue-600">{{ $t('privacyBanner.law') }}</strong> {{ $t('privacyBanner.introSuffix') }}
              </p>
              
              <div class="bg-blue-50 rounded-lg p-3 border border-blue-100">
                <p class="text-xs text-gray-600">
                  <span class="font-medium text-blue-700">{{ $t('privacyBanner.keyProtections') }}</span>
                </p>
                <ul class="mt-2 space-y-1.5 text-xs text-gray-600">
                  <li class="flex items-start gap-2">
                    <svg class="w-3 h-3 text-green-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{{ $t('privacyBanner.bullet1') }}</span>
                  </li>
                  <li class="flex items-start gap-2">
                    <svg class="w-3 h-3 text-green-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{{ $t('privacyBanner.bullet2') }}</span>
                  </li>
                  <li class="flex items-start gap-2">
                    <svg class="w-3 h-3 text-green-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{{ $t('privacyBanner.bullet3') }}</span>
                  </li>
                </ul>
              </div>
              
              <p class="mt-3 text-xs text-gray-500">
                {{ $t('privacyBanner.acknowledgement') }}
              </p>
            </div>

            <div class="pt-4 border-t border-gray-200">
              <div class="flex justify-center">
                <button 
                  @click="$emit('accept')" 
                  class="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-6 py-2.5 text-sm font-medium rounded-lg shadow hover:shadow-md transition-all duration-200"
                >
                  {{ $t('privacyBanner.acceptBtn') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PrivacyBanner',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ['accept']
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active > div,
.modal-fade-leave-active > div {
  transition: transform 0.3s ease;
}

.modal-fade-enter-from > div {
  transform: scale(0.9) translateY(20px);
}

.modal-fade-leave-to > div {
  transform: scale(0.9) translateY(20px);
}
</style>